import type * as THREE from 'three'
import { ESPESSURA_PAINEL_TETO, larguraPainelTeto, type PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import { criarCaixaArredondada, geometriaBase, moldarGeometria, type TransformacaoRepouso } from './malhaDeformavel'

/** Abaulamento do teto no centro, em metros. */
export const ABAULAMENTO_TETO = 0.02

/**
 * Teto deformável.
 *
 * O campo do teto (`deslocamentoTeto`) baixa a LINHA do teto — mais do lado
 * que tocou o solo, com vinco junto à longarina e sobre a coluna B — e empurra
 * o conjunto para o lado oposto, inclinando as colunas. Nada de depressão
 * central circular. Na lateral severa, só a borda do lado atingido desce.
 */
export function baseTeto(perfil: PerfilVeiculo): THREE.BufferGeometry {
  const comprimento = perfil.teto.zDianteiro - perfil.teto.zTraseiro
  const meiaLargura = larguraPainelTeto(perfil) / 2
  const meioComprimento = comprimento / 2
  // abaulado no centro e rente nas bordas, onde encontra colunas e vidros
  return geometriaBase(`teto:${perfil.id}`, () =>
    moldarGeometria(
      criarCaixaArredondada(larguraPainelTeto(perfil), ESPESSURA_PAINEL_TETO, comprimento, [16, 1, 18], 0.045),
      (x, y, z) => [x, y + ABAULAMENTO_TETO * (1 - (x / meiaLargura) ** 2) * (1 - (z / meioComprimento) ** 2 * 0.6), z],
    ),
  )
}

export const repousoTeto = (perfil: PerfilVeiculo): TransformacaoRepouso => ({
  posicao: [0, perfil.tetoY, (perfil.teto.zDianteiro + perfil.teto.zTraseiro) / 2],
})
